import { render, staticRenderFns } from "./StartupError.vue?vue&type=template&id=64248a06"
import script from "./StartupError.vue?vue&type=script&lang=js"
export * from "./StartupError.vue?vue&type=script&lang=js"
import style0 from "./StartupError.vue?vue&type=style&index=0&id=64248a06&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports